import { CLASS_NAME } from 'constants/class-names'
import { EventType } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { CSSUtils } from 'utils/css'
import { TabIndexUtils } from 'utils/tab-index'

const { shareButton: classNames } = CLASS_NAME

export class Share extends ComponentBase {
    /* eslint-disable no-magic-numbers */
    private readonly SHARE_THRESHOLD = 500
    private readonly modal: HTMLDivElement
    private readonly button: HTMLButtonElement

    public constructor(wrapper: HTMLDivElement) {
        super()

        const button = this.getElement<HTMLButtonElement>(
            `.${classNames._}`,
            wrapper
        )
        const modal = this.getElement<HTMLDivElement>(
            `.${classNames.modal}`,
            wrapper
        )

        if (!button || !modal) {
            return
        }
        this.button = button
        this.modal = modal

        // ONLY some themes, if the element exists attach scroll logic
        window.addEventListener(EventType.SCROLL, () => this.handleScroll())
    }

    private handleScroll(): void {
        const pageYOffset = window.pageYOffset
        // if the menu is open don't mess with visibility
        if (!CSSUtils.checkClass(this.modal, classNames.modalIsOpen)) {
            if (pageYOffset >= this.SHARE_THRESHOLD) {
                this.showButton()
            } else {
                this.hideButton()
            }
        }
    }

    // Show / hide header button
    private showButton(): void {
        CSSUtils.addClass(this.button, classNames.isVisible)
        TabIndexUtils.removeTabIndex(this.button)
    }

    private hideButton(): void {
        CSSUtils.removeClass(this.button, classNames.isVisible)
        TabIndexUtils.hideTabIndex(this.button)
    }
}
